/* Zara Attire theme scripts (ported from the original landing page, wired to Shopify) */
(function () {
  'use strict';

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var routes = (window.theme && window.theme.routes) || { cart: '/cart', cartAdd: '/cart/add' };

  /* ---------- Cart helpers ---------- */
  function refreshCount() {
    fetch(routes.cart + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        $$('[data-cart-count]').forEach(function (el) {
          el.textContent = c.item_count > 0 ? '(' + c.item_count + ')' : '';
        });
      })
      .catch(function () {});
  }

  function addToCart(body) {
    return fetch(routes.cartAdd + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: body })
      .then(function (r) {
        return r.json().then(function (j) {
          if (!r.ok) { throw new Error(j.description || j.message || 'Could not add to cart.'); }
          return j;
        });
      });
  }

  /* Quick add on product cards (delegated so it survives editor re-renders) */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quick-add]');
    if (!btn || btn.disabled) { return; }
    var label = $('span', btn);
    var original = label ? label.textContent : '';
    var fd = new FormData();
    fd.append('id', btn.getAttribute('data-quick-add'));
    fd.append('quantity', '1');
    btn.disabled = true;
    addToCart(fd)
      .then(function () {
        if (label) { label.textContent = 'Added'; }
        btn.classList.add('done');
        refreshCount();
      })
      .catch(function () { if (label) { label.textContent = 'Try again'; } })
      .then(function () {
        setTimeout(function () {
          if (label) { label.textContent = original; }
          btn.classList.remove('done');
          btn.disabled = false;
        }, 1600);
      });
  });

  /* Collection sort */
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-sort]');
    if (!sel) { return; }
    var u = new URL(window.location.href);
    u.searchParams.set('sort_by', sel.value);
    u.searchParams.delete('page');
    window.location.href = u.toString();
  });

  /* ---------- New arrivals 3D carousel ---------- */
  function initArrivals(root) {
    var slides = $$('.sl', root), vis = slides.slice(), cur = 0;
    var nameEl = $('[data-cap-name]', root), priceEl = $('[data-cap-price]', root);
    var prev = $('[data-prev]', root), next = $('[data-next]', root), stage = $('[data-stage]', root);
    var pills = $$('.pill[data-f]', root), x0 = null;

    function render() {
      var n = vis.length;
      slides.forEach(function (s) {
        s.setAttribute('data-pos', 'x');
        s.setAttribute('aria-hidden', 'true');
        s.tabIndex = -1;
      });
      if (!n) {
        nameEl.textContent = ''; priceEl.textContent = '';
        prev.disabled = true; next.disabled = true;
        return;
      }
      vis.forEach(function (s, i) {
        var d = ((i - cur) % n + n) % n;
        if (d > n / 2) { d -= n; }
        if (Math.abs(d) <= 1) { s.setAttribute('data-pos', d); }
        s.setAttribute('aria-hidden', d !== 0);
        s.tabIndex = d === 0 ? 0 : -1;
      });
      var s0 = vis[cur];
      nameEl.textContent = s0.getAttribute('data-name') || '';
      priceEl.textContent = s0.getAttribute('data-price') || '';
      prev.disabled = next.disabled = n < 2;
    }
    function go(i) { cur = (i + vis.length) % (vis.length || 1); render(); }

    slides.forEach(function (s) {
      s.addEventListener('click', function (e) {
        if (s.getAttribute('data-pos') !== '0') { e.preventDefault(); go(vis.indexOf(s)); }
      });
    });
    prev.addEventListener('click', function () { go(cur - 1); });
    next.addEventListener('click', function () { go(cur + 1); });
    pills.forEach(function (b) {
      b.addEventListener('click', function () {
        pills.forEach(function (o) { o.setAttribute('aria-pressed', o === b); });
        var f = b.getAttribute('data-f');
        vis = slides.filter(function (s) { return f === 'All' || s.getAttribute('data-cat') === f; });
        cur = 0; render();
      });
    });
    stage.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { go(cur - 1); }
      if (e.key === 'ArrowRight') { go(cur + 1); }
    });
    stage.addEventListener('pointerdown', function (e) { x0 = e.clientX; });
    stage.addEventListener('pointerup', function (e) {
      if (x0 === null) { return; }
      var d = e.clientX - x0; x0 = null;
      if (Math.abs(d) > 40) { go(cur + (d < 0 ? 1 : -1)); }
    });
    render();
  }

  /* ---------- Product rows (best sellers etc.) ---------- */
  function initRow(root) {
    var row = $('[data-row]', root), prev = $('[data-row-prev]', root), next = $('[data-row-next]', root);
    function step(d) { row.scrollBy({ left: d * row.clientWidth, behavior: 'smooth' }); }
    prev.addEventListener('click', function () { step(-1); });
    next.addEventListener('click', function () { step(1); });
  }

  /* ---------- Testimonials ---------- */
  function initTestimonials(root) {
    var row = $('[data-tc-row]', root), pv = $('[data-tc-prev]', root), nx = $('[data-tc-next]', root), fill = $('[data-tc-fill]', root);
    function upd() {
      var m = row.scrollWidth - row.clientWidth;
      pv.disabled = row.scrollLeft < 4;
      nx.disabled = row.scrollLeft > m - 4;
      fill.style.width = Math.min(100, ((row.scrollLeft + row.clientWidth) / row.scrollWidth) * 100) + '%';
    }
    function st(d) {
      var c = $('.tc', row);
      if (c) { row.scrollBy({ left: d * (c.offsetWidth + 24), behavior: 'smooth' }); }
    }
    pv.addEventListener('click', function () { st(-1); });
    nx.addEventListener('click', function () { st(1); });
    row.addEventListener('scroll', upd, { passive: true });
    window.addEventListener('resize', upd);
    upd();
  }

  /* ---------- Product detail ---------- */
  function readWishlist() {
    try { return JSON.parse(window.localStorage.getItem('za-wishlist') || '[]'); } catch (e) { return []; }
  }
  function writeWishlist(list) {
    try { window.localStorage.setItem('za-wishlist', JSON.stringify(list)); } catch (e) {}
  }

  function initPdp(root) {
    var vjson = $('[data-pdp-variants]', root);
    if (!vjson) { return; }
    var variants = [];
    try { variants = JSON.parse(vjson.textContent); } catch (e) {}

    var form = $('[data-pdp-form]', root), idIn = $('[data-variant-id]', root);
    var priceEl = $('[data-pdp-price]', root), stockEl = $('[data-pdp-stock]', root);
    var addBtn = $('[data-pdp-add]', root), errEl = $('[data-pdp-err]', root), skuEl = $('[data-pdp-sku]', root);
    var mainImg = $('[data-pdp-main] img', root), thumbs = $$('.pdp-th', root), qty = $('[data-qty-input]', root);
    var updateUrl = root.hasAttribute('data-update-url'), busy = false;

    function showMedia(id) {
      var t = thumbs.filter(function (b) { return String(b.getAttribute('data-media-id')) === String(id); })[0];
      if (!t) { return; }
      thumbs.forEach(function (o) { o.setAttribute('aria-pressed', o === t); });
      if (mainImg) { mainImg.src = t.getAttribute('data-src'); mainImg.removeAttribute('srcset'); }
    }
    function selectedValues() {
      return $$('[data-option]', root).map(function (fs) {
        var b = $('[aria-pressed="true"]', fs);
        return b ? b.getAttribute('data-value') : null;
      });
    }
    function findVariant() {
      var sel = selectedValues();
      return variants.filter(function (v) {
        return v.options.every(function (o, i) { return o === sel[i]; });
      })[0];
    }
    function update() {
      var v = findVariant();
      if (!v) {
        stockEl.textContent = 'Unavailable';
        addBtn.disabled = true; addBtn.textContent = 'Unavailable';
        return;
      }
      idIn.value = v.id;
      priceEl.textContent = '';
      if (v.compare) {
        var s = document.createElement('s');
        s.className = 'was'; s.textContent = v.compare;
        priceEl.appendChild(s); priceEl.appendChild(document.createTextNode(' '));
      }
      priceEl.appendChild(document.createTextNode(v.price));
      stockEl.textContent = v.available ? 'In stock' : 'Sold out';
      addBtn.disabled = !v.available;
      addBtn.textContent = v.available ? 'Add to Cart' : 'Sold out';
      if (skuEl) { skuEl.textContent = v.sku || '\u2014'; }
      if (v.media) { showMedia(v.media); }
      if (updateUrl && window.history && window.history.replaceState) {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', v.id);
        window.history.replaceState(null, '', u.toString());
      }
    }

    $$('[data-option]', root).forEach(function (fs) {
      var btns = $$('[data-value]', fs), label = $('[data-option-label]', fs);
      btns.forEach(function (b) {
        b.addEventListener('click', function () {
          btns.forEach(function (o) { o.setAttribute('aria-pressed', o === b); });
          if (label) { label.textContent = b.getAttribute('data-value'); }
          update();
        });
      });
    });
    thumbs.forEach(function (b) {
      b.addEventListener('click', function () { showMedia(b.getAttribute('data-media-id')); });
    });

    $$('[data-qty]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        var n = (parseInt(qty.value, 10) || 1) + parseInt(b.getAttribute('data-qty'), 10);
        qty.value = Math.max(1, n);
      });
    });
    qty.addEventListener('change', function () { qty.value = Math.max(1, parseInt(qty.value, 10) || 1); });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (busy || addBtn.disabled) { return; }
      busy = true; errEl.hidden = true;
      var label = addBtn.textContent;
      addBtn.disabled = true;
      addToCart(new FormData(form))
        .then(function () {
          addBtn.textContent = 'Added to cart';
          addBtn.classList.add('done');
          refreshCount();
        })
        .catch(function (err) {
          errEl.textContent = err.message; errEl.hidden = false;
          addBtn.textContent = label;
        })
        .then(function () {
          setTimeout(function () { busy = false; addBtn.classList.remove('done'); update(); }, 1600);
        });
    });

    var wish = $('[data-wish]', root);
    if (wish) {
      var handle = wish.getAttribute('data-wish');
      wish.setAttribute('aria-pressed', readWishlist().indexOf(handle) > -1);
      wish.addEventListener('click', function () {
        var list = readWishlist(), i = list.indexOf(handle);
        if (i > -1) { list.splice(i, 1); } else { list.push(handle); }
        writeWishlist(list);
        wish.setAttribute('aria-pressed', i === -1);
      });
    }

    var share = $('[data-share]', root);
    if (share) {
      share.addEventListener('click', function () {
        var url = share.getAttribute('data-share') || window.location.href;
        if (navigator.share) {
          navigator.share({ title: document.title, url: url }).catch(function () {});
        } else if (navigator.clipboard) {
          navigator.clipboard.writeText(url).then(function () {
            var t = share.textContent;
            share.textContent = 'Link copied';
            setTimeout(function () { share.textContent = t; }, 1600);
          });
        }
      });
    }

    var tabs = $$('.pdp-tl [role="tab"]', root), panels = $$('.pdp-pn', root);
    tabs.forEach(function (b) {
      b.addEventListener('click', function () {
        tabs.forEach(function (o) { o.setAttribute('aria-selected', o === b); });
        panels.forEach(function (p) { p.hidden = p.getAttribute('data-p') !== b.getAttribute('data-t'); });
      });
    });

    var rrow = $('[data-rec-row]', root);
    if (rrow) {
      $('[data-rec-prev]', root).addEventListener('click', function () { rrow.scrollBy({ left: -rrow.clientWidth, behavior: 'smooth' }); });
      $('[data-rec-next]', root).addEventListener('click', function () { rrow.scrollBy({ left: rrow.clientWidth, behavior: 'smooth' }); });
    }
  }

  /* ---------- Init (also re-runs when sections load in the theme editor) ---------- */
  function once(el, fn) {
    if (el.__zaInit) { return; }
    el.__zaInit = true;
    fn(el);
  }
  function initAll(scope) {
    $$('[data-arrivals]', scope).forEach(function (el) { once(el, initArrivals); });
    $$('[data-row-section]', scope).forEach(function (el) { once(el, initRow); });
    $$('.tst', scope).forEach(function (el) { if ($('[data-tc-row]', el)) { once(el, initTestimonials); } });
    $$('[data-pdp]', scope).forEach(function (el) { once(el, initPdp); });
  }
  initAll(document);
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
